import {
    type NodeCfg,
} from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';
import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { NodeSpec } from './NodeSpec';
import { defineControlOpts } from '../../controls/FlowNodeControl';
import { defaultControlUpdateValueHandler } from '@redviking/argonaut-core-ui/src/applet/design/flows/controls/control-event-handler';

export const addMaterialNoteUiNodeSpec: NodeSpec<NodeCfg<'addMaterialNote'>> = {
    kindLabel: 'Add Material Note',
    nodeCategory: 'material',
    requiredSockets: [ 'materialId', 'trigger', 'note' ],
    controls: nodeCfg => ({
        location: defineControlOpts({
            value: nodeCfg.controlValues.location,
            cfg: {
                kind: 'location',
            },
            on: { 'update:value': defaultControlUpdateValueHandler },
        }),
        isConcern: defineControlOpts({
            value: nodeCfg.controlValues.isConcern,
            cfg: {
                kind: 'boolean',
                label: 'Note Is Concern',
            },
            on: { 'update:value': defaultControlUpdateValueHandler },
        }),
    }),
    cfg: () => ({
        disabled: false,
        id: getUID(),
        kind: 'addMaterialNote',
        controlValues: {
            isConcern: false,
            location: {
                id: '',
            },
        },
    }),
    inputs: nodeCfg => ({
        trigger: {
            socket: 'event',
            label: 'Trigger',
        },
        materialId: {
            socket: 'string',
            label: 'Material Id',
        },
        note: {
            label: 'Note',
            socket: 'string',
            controlOpts: defineControlOpts({
                value: nodeCfg.socketDefaults?.inputs?.note,
                cfg: {
                    kind: 'text',
                },
                on: { 'update:value': defaultControlUpdateValueHandler },
            }),
        },
    }),
    outputs: () => ({
        next: {
            label: 'Next',
            socket: 'event',
        },
    }),
    validator: node => {
        const errors: Record<string, string> = {};
        if (!node.controlValues.location) {
            errors.location = 'Location is required';
        } else if ('deployParamKind' in node.controlValues.location) {
            if (!node.controlValues.location.deployParamId) {
                errors.location = 'Location deployment parameter is required';
            }
        } else if (!node.controlValues.location.id) {
            errors.location = 'Location is required';
        }
        return Object.keys(errors).length ? errors : true;
    },
};
